export class PPCFileDb {
  private db: IDBDatabase | null;
  private pendingClear: boolean;

  constructor() {
    const dbReq = indexedDB.open('ppcdb', 2);
    this.db = null;
    this.pendingClear = false;
    this.clear = this.clear.bind(this);

    dbReq.addEventListener('error', () => {
      console.error('File db error:', dbReq.error);
    });

    dbReq.onupgradeneeded = () => {
      this.db = dbReq.result;
      if (!this.db.objectStoreNames.contains('ppcBuffers')) {
        this.db.createObjectStore('ppcBuffers', { autoIncrement: true });
      }
    };

    dbReq.onerror = (event) => {
      const target = event.target as IDBOpenDBRequest | null;
      console.error('error opening file db', target?.error);
    };

    dbReq.onsuccess = () => {
      this.db = dbReq.result;
      // Clear on startup to prevent accumulation across page reloads
      this.clear();
      // Also execute any pending clear request
      if (this.pendingClear) {
        this.pendingClear = false;
        this.clear();
      }
    };
  }

  clear() {
    if (this.db === null) {
      // DB not ready yet, queue the clear for when it's ready
      this.pendingClear = true;
      return;
    }
    try {
      const transaction = this.db.transaction(['ppcBuffers'], 'readwrite');
      const objectStore = transaction.objectStore('ppcBuffers');
      objectStore.clear();
    } catch {
      // Ignore errors during cleanup
    }
  }

  put(buffer: ArrayBuffer, url: string) {
    if (this.db === null) {
      return;
    }
    const tx = this.db.transaction(['ppcBuffers'], 'readwrite');
    const store = tx.objectStore('ppcBuffers');
    store.put(buffer, url);
  }

  delete(url: string) {
    if (this.db === null) {
      return;
    }
    const tx = this.db.transaction(['ppcBuffers'], 'readwrite');
    const store = tx.objectStore('ppcBuffers');
    store.delete(url);
  }
}
